import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="section max-w-[900px] mx-auto px-6" data-testid="not-found-page">
      <div className="overline">404</div>
      <h1 className="font-serif-editorial tight-track mt-6" style={{ fontSize: "clamp(2.4rem, 5vw, 4rem)", lineHeight: 1 }}>
        Nothing here.
      </h1>
      <p className="mt-8 text-lg opacity-80">The page you&apos;re looking for has moved or does not exist.</p>
      <div className="mt-10">
        <Link to="/" className="btn-olive">Return home</Link>
      </div>
    </div>
  );
}
